import {
    QueryPlanPage,
    GetPlanInfo,
    SubmitPlan,
    AddPlan,
    DeletePlan,
    UpdateVisitPlan,
    QueryCustomerReport,
    GetProcessScorePage,
    GetUserScorePage,
    QuerySubPlanPage,
    QuerySubReportPage,
    QueryActionList,
    AddAction,
    UpdateAction,
    DeleteAction,
    QuerySubActionList,
    MarkAction,
    QueryAbnormal,
    SaveAbnormal,
    QueryRisk,
    SaveRisk,
    QueryAbnormalByCustomer,
    QueryRiskByCustomer,
    UpdateRisk,
    DealRisk,
    ConfirmRisk,
    ValidateRisk,
    UnsolvableRisk,
    SaveWorkAction,
    QueryWorkAction,
    UpdateWorkAction,
    ConfirmAction,
    FinishAction,
    VerifyAction,
    DelayAction,
    GetActionInfo,
    GetRiskInfo,
    GetActionListByIssueId,
    QueryFocusPage,
    SaveFocus,
    UpdateFocus,
    QueryActionByFocus,
    DeleteFocus,
    QueryTotalKeypoint,
    QuerySubKeypoint,
    QueryKeypointMain,
    QuerySubKeypointPage,
    QueryActionCount,
    QueryUserDetailData,
    QueryUserMain,
    QueryUserPlanList,
    QueryUserReportList,
    QueryUserActionList,
    QueryUserKeypointList,
    QueryUserMainInfo,
    QueryUserCustomerList,
    QueryUserCustomerPlan,
    QueryUserActionInfo,
    QueryUserKeyman,
    QueryUserPlankeyman,
    QueryUserActionVisitInfo,
    ConfirmKeypoint,
    FinishKeypoint,
    CancelKeypoint,
    VerifyKeypoint,
    QueryUserActionVisitList,
    QueryFitCustomer,
    QueryUserKeypointAll,
    QueryCollectionPage,
    QueryAssginKeypointPage,
    SaveAssginKeupoint,
    UpdateAssginKeypoint,
    DeleteAssginKeypoint,
    QuerySuggestionEdit,
    QuerySuggestionPropose,
    QuerySuggestionPage,
    SaveSuggestion,
    DeleteSuggestion,
    UpdateSuggestion,
    QueryVisitPlanByKeypoint,
    QueryFitRate,
    VerifyPasssAll,
    QueryWithoutPlan
} from '@/request/plan';
import {
    AddReport,
    GetReportInfo,
    QueryReportPage,
    MarkPlanNotVisit,
    GetFocusInfo,
    QueryUserData,
    AssginKeypoint,
    QueryUserDetailVisit,
    QueryUserKeypointVisitList,
    SaveSubmitPlan,
    UpdateCollection,
    QueryKeypointMap,
    ConfirmAssginKeypoint,
    QueryAssginKeypointInfo,
    QueryAssginKeypointAction,
    LinkAssginKeypointAction,
    UpdateAssginKeypointAction,
    QueryAssginKeypointActionInfo,
    DeleteAssginKeypointAction,
    QueryKeymanByParams,
    CancelAction,
    QueryAreaMain,
    QueryUserSubPlanInfo,
    QueryUserSubVisitInfo
} from '../../request/plan';
import store from '..';
import { QueryActionPlan, QueryVisitList } from '@/request/compoent';

export default {
    namespace: true,
    state: {
        planList: {},
        submitPlan: {},
        submitList: [],
        reportList: {},
        donePlan: {},
        customerReport: {},
        scoreList: {},
        userScoreList: {},
        examineList: {},
        collect: {}
    },
    mutations: {
        SET_PLAN_PAGE(state, planList) {
            state.planList = planList;
        },

        SET_SUBMIT_PLAN(state, submitPlan) {
            state.submitPlan = submitPlan;
        },

        SET_DONE_PLAN(state, donePlan) {
            state.donePlan = donePlan;
        },

        SET_REPORT_LIST(state, reportList) {
            state.reportList = reportList;
        },

        SET_CUSTOMER_REPORT(state, customerReport) {
            state.customerReport = customerReport;
        },

        SET_SCORE_LIST(state, scoreList) {
            state.scoreList = scoreList;
        },

        SET_USER_SCORE_LIST(state, userScoreList) {
            state.userScoreList = userScoreList;
        },

        SET_COLLECT_PAGE(state, collect) {
            state.collect = collect;
        }
    },
    actions: {
        QUERY_PLAN_PAGE: async ({ commit }, payload) => {
            let res = await QueryPlanPage(payload);
            if (res.code == 200) {
                commit('SET_PLAN_PAGE', res.data ?? {});
            }
            return res;
        },

        QUERY_SUBMIT_PLAN: async ({ commit }, payload) => {
            let res = await QueryPlanPage(payload);
            if (res.code == 200) {
                commit('SET_SUBMIT_PLAN', res.data ?? {});
            }
            return res;
        },

        QUERY_DONE_PLAN: async ({ commit }, payload) => {
            let res = await QueryPlanPage(payload);
            if (res.code == 200) {
                commit('SET_DONE_PLAN', res.data ?? {});
            }
            return res;
        },

        ADD_PLAN: async ({}, payload) => {
            let res = await AddPlan(payload);
            return res;
        },

        GET_PLAN_INFO: async ({ commit }, payload) => {
            let res = await GetPlanInfo(payload);
            return res;
        },

        SAVE_SUBMIT_PLAN: async ({}, payload) => {
            let res = await SaveSubmitPlan(payload);
            return res;
        },

        SUBMIT_PLAN: async ({}, payload) => {
            let res = await SubmitPlan(payload);
            return res;
        },

        DELETE_PLAN: async ({}, payload) => {
            let res = await DeletePlan(payload);
            return res;
        },

        UPDATE_VISIT_PLAN: async ({}, payload) => {
            let res = await UpdateVisitPlan(payload);
            return res;
        },

        QUERY_VISIT_PLAN_BY_KEYPOINT: async ({}, payload) => {
            let res = await QueryVisitPlanByKeypoint(payload);
            return res;
        },
        // 汇报接口

        QUERY_REPORT_LIST: async ({ commit }, payload) => {
            let res = await QueryReportPage(payload);
            if (res?.code == 200) {
                commit('SET_REPORT_LIST', res.data ?? {});
            }
            return res;
        },

        QUERY_CUSTOMER_REPORT: async ({ commit }, payload) => {
            let res = await QueryCustomerReport(payload);
            if (res?.code == 200) {
                commit('SET_CUSTOMER_REPORT', res.data ?? {});
            }
            return res;
        },

        GET_REPORT_INFO: async ({}, payload) => {
            let res = await GetReportInfo(payload);
            return res;
        },

        ADD_REPORT: async ({}, payload) => {
            let res = await AddReport(payload);
            return res;
        },

        SUBMIT_REPORT: async ({}, payload) => {
            let res = await SubmitReport(payload);
            return res;
        },

        MARK_PLAN_NOT_VISIT: async ({}, payload) => {
            let res = await MarkPlanNotVisit(payload);
            return res;
        },

        Get_PROCESS_SCORE: async ({ commit }, payload) => {
            let res = await GetProcessScorePage(payload);
            if (res?.code == 200) {
                commit('SET_SCORE_LIST', res.data ?? {});
            }
            return res;
        },

        GET_USER_SCORE_PAGE: async ({ commit }, payload) => {
            let res = await GetUserScorePage(payload);
            if (res?.code == 200) {
                commit('SET_USER_SCORE_LIST', res.data ?? {});
            }
            return res;
        },

        // 下属计划
        QUERY_SUB_PLAN_PAGE: async ({ commit }, payload) => {
            let res = await QuerySubPlanPage(payload);
            return res;
        },

        // 下属汇报
        QUERY_SUB_REPORT_PAGE: async ({ commit }, payload) => {
            let res = await QuerySubReportPage(payload);
            return res;
        },

        // 行动计划
        QUERY_ACTION_LIST: async ({}, payload) => {
            let res = await QueryActionList(payload);
            return res;
        },

        QUERY_SUB_ACTION_LIST: async ({}, payload) => {
            let res = await QuerySubActionList(payload);
            return res;
        },

        ADD_ACTION: async ({}, payload) => {
            let res = await AddAction(payload);
            return res;
        },

        CONFIRM_ACTION: async ({}, payload) => {
            let res = await ConfirmAction(payload);
            return res;
        },

        DELAY_ACTION: async ({}, payload) => {
            let res = await DelayAction(payload);
            return res;
        },

        VERIFY_ACTION: async ({}, payload) => {
            let res = await VerifyAction(payload);
            return res;
        },

        UPDATE_ACTION: async ({}, payload) => {
            let res = await UpdateAction(payload);
            return res;
        },

        FINISH_ACTION: async ({}, payload) => {
            let res = await FinishAction(payload);
            return res;
        },

        MARK_ACTION: async ({}, payload) => {
            let res = await MarkAction(payload);
            return res;
        },

        GET_ACTION_INFO: async ({}, payload) => {
            let res = await GetActionInfo(payload);
            return res;
        },

        CANCEL_ACTION: async ({}, payload) => {
            let res = await CancelAction(payload);
            return res;
        },

        DELETE_ACTION: async ({}, payload) => {
            let res = await DeleteAction(payload);
            return res;
        },

        SAVE_WORK_ACTION: async ({}, payload) => {
            let res = await SaveWorkAction(payload);
            return res;
        },

        QUERY_WORK_ACTION: async ({}, payload) => {
            let res = await QueryWorkAction(payload);
            return res;
        },

        UPDATE_WORK_ACTION: async ({}, payload) => {
            let res = await UpdateWorkAction(payload);
            return res;
        },

        //异常风险
        QUERY_ABNORMAL: async ({}, payload) => {
            let res = await QueryAbnormal(payload);
            return res;
        },

        SAVE_ABNORMAL: async ({}, payload) => {
            let res = await SaveAbnormal(payload);
            return res;
        },

        QUERY_ABNORMAL_BY_CUSTOMER: async ({}, payload) => {
            let res = QueryAbnormalByCustomer(payload);
            return res;
        },

        QUERY_RISK: async ({}, payload) => {
            let res = await QueryRisk(payload);
            return res;
        },

        GET_RISK_INFO: async ({}, payload) => {
            let res = await GetRiskInfo(payload);
            return res;
        },

        GET_ACTION_LIST_BY_ISSUEID: async ({}, payload) => {
            let res = await GetActionListByIssueId(payload);
            return res;
        },

        SAVE_RISK: async ({}, payload) => {
            let res = await SaveRisk(payload);
            return res;
        },

        UPDATE_RISK: async ({}, payload) => {
            let res = await UpdateRisk(payload);
            return res;
        },

        DEAL_RISK: async ({}, payload) => {
            let res = await DealRisk(payload);
            return res;
        },

        CONFIRM_RISK: async ({}, payload) => {
            let res = await ConfirmRisk(payload);
            return res;
        },

        VALIDATE_RISK: async ({}, payload) => {
            let res = await ValidateRisk(payload);
            return res;
        },

        UNSOLVABLE_RISK: async ({}, payload) => {
            let res = await UnsolvableRisk(payload);
            return res;
        },

        QUERY_RISK_BY_CUSTOMER: async ({}, payload) => {
            let res = await QueryRiskByCustomer(payload);
            return res;
        },

        // 重点工作
        QUERY_FOCUS_PAGE: async ({}, payload) => {
            let res = await QueryFocusPage(payload);
            return res;
        },

        // 我的关注
        QUERY_MY_COLLECTION: async ({ commit }, payload) => {
            let res = await QueryCollectionPage(payload);
            if (res?.code == 200) {
                commit('SET_COLLECT_PAGE', res.data);
            }
            return res;
        },

        QUERY_KEYPOINT_MAP: async ({}, payload) => {
            let res = await QueryKeypointMap(payload);
            return res;
        },

        UPDATE_COLLECTION: async ({}, payload) => {
            let res = await UpdateCollection(payload);
            return res;
        },

        SAVE_FOCUS: async ({}, payload) => {
            let res = await SaveFocus(payload);
            return res;
        },

        DELETE_FOCUS: async ({}, payload) => {
            let res = await DeleteFocus(payload);
            return res;
        },

        UPDATE_FOCUS: async ({}, payload) => {
            let res = await UpdateFocus(payload);
            return res;
        },

        ASSGIN_KEYPOINT: async ({}, payload) => {
            let res = await AssginKeypoint(payload);
            return res;
        },

        CONFIRM_KEYPOINT: async ({}, payload) => {
            let res = await ConfirmKeypoint(payload);
            return res;
        },

        FINISH_KEYPOINT: async ({}, payload) => {
            let res = await FinishKeypoint(payload);
            return res;
        },

        VERIFY_KEYPOINT: async ({}, payload) => {
            let res = await VerifyKeypoint(payload);
            return res;
        },

        CANCEL_KEYPOINT: async ({}, payload) => {
            let res = await CancelKeypoint(payload);
            return res;
        },

        GET_FOCUS_INFO: async ({}, payload) => {
            let res = await GetFocusInfo(payload);
            return res;
        },

        QUERY_SUB_FOCUS_PAGE: async ({}, payload) => {
            let res = await QuerySubKeypointPage(payload);
            return res;
        },

        QUERY_ACTION_BY_FOCUS: async ({}, payload) => {
            let res = await QueryActionByFocus(payload);
            return res;
        },

        QUERY_TOTAL_KEYPOINT: async ({}, payload) => {
            let res = await QueryTotalKeypoint(payload);
            return res;
        },
        QUERY_SUB_KEYPOINT: async ({}, payload) => {
            let res = await QuerySubKeypoint(payload);
            return res;
        },

        QUERY_SUGGESTION_EDIT: async ({}, payload) => {
            let res = await QuerySuggestionEdit(payload);
            return res;
        },

        QUERY_SUGGESTION_PROPOSE: async ({}, payload) => {
            let res = await QuerySuggestionPropose(payload);
            return res;
        },

        QUERY_SUGGESTION_PAGE: async ({}, payload) => {
            let res = await QuerySuggestionPage(payload);
            return res;
        },

        SAVE_SUGGESTION: async ({}, payload) => {
            let res = await SaveSuggestion(payload);
            return res;
        },

        DELETE_SUGGESTION: async ({}, payload) => {
            let res = await DeleteSuggestion(payload);
            return res;
        },

        UPDATE_SUGGESTION: async ({}, payload) => {
            let res = await UpdateSuggestion(payload);
            return res;
        },

        QUERY_ACTION_PLAN: async ({}, payload) => {
            let res = await QueryActionPlan(payload);
            return res;
        },
        QUERY_VISIT_LIST: async ({}, payload) => {
            let res = await QueryVisitList(payload);
            return res;
        },

        QUERY_KEYPOINT_MAIN: async ({}, payload) => {
            let res = await QueryKeypointMain(payload);
            return res;
        },

        QUERY_ACTION_COUNT: async ({}, payload) => {
            let res = await QueryActionCount(payload);
            return res;
        },

        QUERY_USER_DATA: async ({}, payload) => {
            let res = await QueryUserData(payload);
            return res;
        },

        QUERY_USER_DETAIL_DATA: async ({}, payload) => {
            let res = await QueryUserDetailData(payload);
            return res;
        },

        QUERY_USER_DETAIL_VISIT: async ({}, payload) => {
            let res = await QueryUserDetailVisit(payload);
            return res;
        },

        //用户汇总
        QUERY_USER_MAIN: async ({}, payload) => {
            let res = await QueryUserMain(payload);
            return res;
        },
        QUERY_USER_MAIN_INFO: async ({}, payload) => {
            let res = await QueryUserMainInfo(payload);
            return res;
        },
        QUERY_USER_PLAN_LIST: async ({}, payload) => {
            let res = await QueryUserPlanList(payload);
            return res;
        },
        QUERY_USER_REPORT_LIST: async ({}, payload) => {
            let res = await QueryUserReportList(payload);
            return res;
        },
        QUERY_USER_ACTION_LIST: async ({}, payload) => {
            let res = await QueryUserActionList(payload);
            return res;
        },

        QUERY_USER_ACTION_VISIT_LIST: async ({}, payload) => {
            let res = await QueryUserActionVisitList(payload);
            return res;
        },
        QUERY_USER_KEYPOINT_LIST: async ({}, payload) => {
            let res = await QueryUserKeypointList(payload);
            return res;
        },
        QUERY_USER_KEYPOINT_VISIT_LIST: async ({}, payload) => {
            let res = await QueryUserKeypointVisitList(payload);
            return res;
        },
        QUERY_USER_KEYPOINT_ALL: async ({}, payload) => {
            let res = await QueryUserKeypointAll(payload);
            return res;
        },
        QUERY_USER_CUSTOMER_PLAN: async ({}, payload) => {
            let res = await QueryUserCustomerPlan(payload);
            return res;
        },
        QUERY_USER_ACTION_INFO: async ({}, payload) => {
            let res = await QueryUserActionInfo(payload);
            return res;
        },

        QUERY_USER_ACTION_VISIT_INFO: async ({}, payload) => {
            let res = await QueryUserActionVisitInfo(payload);
            return res;
        },

        QUERY_USER_SUB_PLAN_INFO: async ({}, payload) => {
            let res = await QueryUserSubPlanInfo(payload);
            return res;
        },

        QUERY_USER_SUB_VISIT_INFO: async ({}, payload) => {
            let res = await QueryUserSubVisitInfo(payload);
            return res;
        },

        QUERY_USER_KEYMAN: async ({}, payload) => {
            let res = await QueryUserKeyman(payload);
            return res;
        },

        QUERY_USER_PLAN_KEYMAN: async ({}, payload) => {
            let res = await QueryUserPlankeyman(payload);
            return res;
        },

        // 符合率客户
        QUERY_FIT_CUSTOMER: async ({}, payload) => {
            let res = await QueryFitCustomer(payload);
            return res;
        },

        //w我的指派重点工作
        QUERY_ASSGIN_KEYPOINT: async ({}, payload) => {
            let res = await QueryAssginKeypointPage(payload);
            return res;
        },
        SAVE_ASSGIN_KEYPOINT: async ({}, payload) => {
            let res = await SaveAssginKeupoint(payload);
            return res;
        },
        UPDATE_ASSGIN_KEYPOINT: async ({}, payload) => {
            let res = await UpdateAssginKeypoint(payload);
            return res;
        },
        DELETE_ASSGIN_KEYPOINT: async ({}, payload) => {
            let res = await DeleteAssginKeypoint(payload);
            return res;
        },
        CONFIRM_ASSGIN_KEYPOINT: async ({}, payload) => {
            let res = await ConfirmAssginKeypoint(payload);
            return res;
        },
        QUERY_ASSGIN_KEYPOINT_INFO: async ({}, payload) => {
            let res = await QueryAssginKeypointInfo(payload);
            return res;
        },
        QUERY_ASSGIN_KEYPOINT_ACTION: async ({}, payload) => {
            let res = await QueryAssginKeypointAction(payload);
            return res;
        },

        LINK_ASSGIN_KEYPOINT_ACTION: async ({}, payload) => {
            let res = await LinkAssginKeypointAction(payload);
            return res;
        },
        UPDATE_ASSGIN_KEYPOINT_ACTION: async ({}, payload) => {
            let res = await UpdateAssginKeypointAction(payload);
            return res;
        },
        QUERY_ASSGIN_KEYPOINT_ACTION_INFO: async ({}, payload) => {
            let res = await QueryAssginKeypointActionInfo(payload);
            return res;
        },
        DELETE_ASSGIN_KEYPOINT_ACTION: async ({}, payload) => {
            let res = await DeleteAssginKeypointAction(payload);
            return res;
        },

        //
        QUERY_KEYMAN_BY_PARAMS: async ({}, payload) => {
            let res = await QueryKeymanByParams(payload);
            return res;
        },

        //符合率
        QUERY_FIT_RATE: async ({}, payload) => {
            let res = await QueryFitRate(payload);
            return res;
        },

        QUERY_AREA_MAIN: async ({}, payload) => {
            let res = await QueryAreaMain(payload);
            return res;
        },

        VERIFY_PASS_ALL: async ({}, payload) => {
            let res = await VerifyPasssAll(payload);
            return res;
        },

        QUERY_WITHOUT_PLAN: async ({}, payload) => {
            let res = await QueryWithoutPlan(payload);
            return res;
        }
    }
};
